import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import { formatMoneda, validaMonto } from "../../../util/varios";
import axios from "axios";
import { DangerButton, SuccessButton } from "../../../ui/buttons/Button";
import { Input, Radio } from "../../../ui/inputs/Input";

export const ModalConfiguracionRentas = (props) => {
  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const [bloquear, setDesbloquear] = useState(true);
  const [bloquear2, setDesbloquear2] = useState(true);
  const [values, setValues] = useState({
    periodopag: 0,
    periododeclaracio: 0,
    factorcalcul: 0,
    valorporcentua: 0,
    tipointere: 0,
    porcentajeintere: 0,
    porcentajerecarg: 0,
    mesesdecladef: 0,
    ptoimpr: 0,
    diavendeud: 0,
    factormult: 0,
    valormult: 0,
    diavendeudare: 0,
    declaracionwe: 0,
    notifrit: 0,
    diavendeuda1: 0,
    diavendeuda2: 0,
    mesdesdequincen: 0,
    porcenimpuest: 0,
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records] = useState([]);
  const txtInteresMora = useRef();
  const txtRecargoMora = useRef();

  const onChangeChecked = (e) => {
    if (e.target.name === "factorcalcul") {
      setValues({ ...values, [e.target.name]: parseInt(e.target.value) });
    } else if (e.target.name === "tipointere") {
      if (e.target.value === "1") {
        setDesbloquear2(false);
      } else {
        txtInteresMora.current.value = "0,00";
        setDesbloquear2(true);
      }
      setValues({ ...values, [e.target.name]: parseInt(e.target.value) });
    } else if (e.target.name === "valorporcentua") {
      console.log("valor: " + e.target.value);
      setValues({ ...values, [e.target.name]: parseInt(e.target.value) });
      console.log(values.valorporcentua);
    } else if (e.target.name === "declaracionwe") {
      console.log(e.target.value === "true" ? true : false);
      setValues({
        ...values,
        [e.target.name]: e.target.value === "true" ? true : false,
      });
    }
  };

  const actualizarConfig = () => {
    let endpoint = `${op.conexion}/api/comun/actualizarmodulo`;
    let body;
    setActivate(true);

    body = {
      tipoconf: 6,
      periodo: null,
      factor: parseInt(values.factorcalcul),
      valor: parseInt(values.valorporcentua),
      decla: null,
      tipint: parseInt(values.tipointere),
      porint: txtInteresMora.current.value.replace(",", "."),
      porrec: txtRecargoMora.current.value.replace(",", "."),
      meses: null,
      diaven: null,
      diavenreg: null,
      pto: null,
      factor1: null,
      valormul: null,
      declaweb: values.declaracionwe,
      diavenqui1: null,
      diavenqui2: null,
      cmbMes: null,
      descu: records,
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Configuración Actualizada.",
            icono: "exito",
          });
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const salir = () => {
    props.setShow(false);
  };

  const desbloquear = () => {
    setDesbloquear(false);
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    seleccionnarModulo();
    props.onHideCancela();
  };

  const seleccionnarModulo = () => {
    let nomtab = "configrentas";
    let endpoint =
      op.conexion + `/api/comun/seleccionarmodulo?&nomtab=${nomtab}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setValues(response.data);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleInputMonto = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which === 13 || typeof event.which === "undefined") {
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.length
        );
      }
      console.log(event.target.value);
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  useEffect(() => {
    seleccionnarModulo();
  }, []);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {}}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant rounded-top text-light">
        <h3 className="fw-bold m-0">Configuracion de Rentas Inmobiliarias</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap align-items-center">
        <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
          <legend className="float-none w-auto m-0">
            Fáctor para el Calculo
          </legend>
          <div class="col-4 m-0 p-0">
            <Radio label = 'Bolivares(Bs.)'
              name="factorcalcul"
              value={1}
              defaultChecked={values.factorcalcul === 1 ? true : false}
              id="factorcalcul1"
              onChange={onChangeChecked}
            />
          </div>
          <div class="col-4 m-0 p-0">
            <Radio label = 'Unidades Tributarias (U.T.)'
              name="factorcalcul"
              value={2}
              defaultChecked={values.factorcalcul === 2 ? true : false}
              id="factorcalcul2"
              onChange={onChangeChecked}
            />
          </div>
          <div class="col-4 m-0 p-0">
            <Radio label = 'Petros'
              name="factorcalcul"
              value={3}
              defaultChecked={values.factorcalcul === 3 ? true : false}
              id="factorcalcul3"
              onChange={onChangeChecked}
            />
          </div>
          <div class="col-4 m-0 p-0">
            <Radio label = 'Sueldo Minimo'
              name="factorcalcul"
              value={4}
              defaultChecked={values.factorcalcul === 4 ? true : false}
              id="factorcalcul4"
              onChange={onChangeChecked}
            />
          </div>
          <div class="col-4 m-0 p-0">
            <Radio label = 'UCAMP'
              name="factorcalcul"
              value={5}
              defaultChecked={values.factorcalcul === 5 ? true : false}
              id="factorcalcul5"
              onChange={onChangeChecked}
            />
          </div>
          <div class="col-4 m-0 p-0">
            <Radio label = 'Otros'
              name="factorcalcul"
              value={6}
              defaultChecked={values.factorcalcul === 6 ? true : false}
              id="factorcalcul6"
              onChange={onChangeChecked}
            />
          </div>
        </fieldset>
        <fieldset className="col-6 m-0 p-2 d-flex flex-wrap border-azul rounded">
          <legend className="float-none w-auto"> Intereses de Mora</legend>
          <div class="col-auto m-0 p-0">
            <Radio label = 'Fijo'
              name="tipointere"
              value={1}
              defaultChecked={values.tipointere === 1 ? true : false}
              id="tipointere1"
              onChange={onChangeChecked}
            />
          </div>
          <div className="col m-0 p-0 px-2">
            <Input
              disabled={bloquear2}
              defaultValue={
                values.porcentajeintere
                  ? formatMoneda(
                      values.porcentajeintere
                        .toString()
                        .replace(",", "")
                        .replace(".", ","),
                      ",",
                      ".",
                      2
                    )
                  : ""
              }
              onKeyUp={handleInputMonto}
              ref={txtInteresMora}
            />
          </div>
          <div class="col-auto m-0 p-0">
            <Radio label = 'Según Tasa'
              name="tipointere"
              value={2}
              defaultChecked={values.tipointere === 2 ? true : false}
              id="tipointere2"
              onChange={onChangeChecked}
            />
          </div>
        </fieldset>
        <div className="col-6 m-0 p-0 d-flex gap-2 justify-content-center">
          <span className="fw-bold">
            Declaración En Linea (Internet)
          </span>
          <div class="col-auto m-0 p-0">
            <Radio label = 'Si'
              name="declaracionwe"
              value="true"
              defaultChecked={values.declaracionwe === true ? true : false}
              id="declaracionwe1"
              onChange={onChangeChecked}
            />
          </div>
          <div class="col-auto m-0 p-0">
            <Radio label = 'No'
              name="declaracionwe"
              value="false"
              defaultChecked={values.declaracionwe === false ? true : false}
              id="declaracionwe2"
              onChange={onChangeChecked}
            />
          </div>
        </div>
        <div class="col-4 m-0 ml-auto p-0">
          <Input label = 'Recargos por Mora:'
            defaultValue={
              values.porcentajerecarg
                ? formatMoneda(
                    values.porcentajerecarg
                      .toString()
                      .replace(",", "")
                      .replace(".", ","),
                    ",",
                    ".",
                    2
                  )
                : ""
            }
            onKeyUp={handleInputMonto}
            ref={txtRecargoMora}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton disabled={bloquear} onClick={actualizarConfig}>
          Aceptar
        </SuccessButton>
        <DangerButton onClick={salir}>Salir</DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <Dimmer active={activate}></Dimmer>
    </Modal>
  );
};
